import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TotemType } from '../settings/interfaces/totem';
import { TotemPainelType } from '../settings/interfaces/totemPainel';
import { ServerUrlService } from './server-url.service';

@Injectable({
    providedIn: 'root'
})
export class TotemPainelService {
    public totem! : number
    private headers: any
    public lastInserted: number | undefined
    constructor(private httpClient: HttpClient, private serverUrl: ServerUrlService) {
        this.headers = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    }

    getTotems(): Observable<any> {
        return this.httpClient.get(`${this.serverUrl.getUrl()}/totem`,
            this.headers
        )
    }

    getTotemPaineis(id: number): Observable<any> {
        return this.httpClient.get(`${this.serverUrl.getUrl()}/totem-painel/${id}`,
            this.headers
        )
    }

    getPainelTotem(id: number): Observable<any> {
        return this.httpClient.get(`${this.serverUrl.getUrl()}/painel-totem/${id}`,
            this.headers
        )
    }

    updateTotemPainel(formData: TotemPainelType) {
        this.httpClient.put(
            `${this.serverUrl.getUrl()}/totem-painel`,
            JSON.stringify(formData),
            this.headers
        ).subscribe(
            (resp: any) => {
            }
        )
    }

    deleteTotemPainel(id: number) {
        this.httpClient.delete(
            `${this.serverUrl.getUrl()}/totem-painel/${id}`,
            this.headers
        ).subscribe(
            (resp: any) => {
            }
        )
    }

    getEmpresas(): Observable<any> {
        return this.httpClient.get(`${this.serverUrl.getUrl()}/paineis-empresa/`,
            this.headers
        )
    }

    insertTotem(formData: TotemType) {
        this.httpClient.post(
            `${this.serverUrl.getUrl()}/totem`,
            JSON.stringify(formData),
            this.headers
        ).subscribe(
            (resp: any) => {
                this.lastInserted = resp.rows[0].id
            }
        )
    }

    insertTotemPainel(formData: TotemPainelType) {
        this.httpClient.post(
            `${this.serverUrl.getUrl()}/totem-painel`,
            JSON.stringify(formData),
            this.headers
        ).subscribe(
            () => {

            }
        )
    }

    updateTotem(formData: TotemType) {
        this.httpClient.put(
            `${this.serverUrl.getUrl()}/totem`,
            JSON.stringify(formData),
            this.headers
        ).subscribe(
            (resp: any) => {
                this.lastInserted = resp.rows[0].id
            }
        )
    }

    deleteTotem(id: number): void {
        this.httpClient.delete(
            `${this.serverUrl.getUrl()}/totem/${id}`, this.headers
        ).subscribe(
            (result) => {
                console.log('Delete', result)
            }
        )
    }

}
